import React from 'react';
import PBV_icon from '../../assets/pbv.png'
import {getwayApi} from '../../../config/Constants'
import './LoadingScreen.scss'


export const LoadingScreen = ({ config, formId, loadingMessage }) => {

    return (
        <div className='loader-page' style={{ borderColor: 'red', borderWidth: 1 }}>
            <div className='spinner-container'>
                <div className='spinner'></div>
                <p className='loading-message'>{loadingMessage}</p>
            </div>
            <img src={PBV_icon} alt="powered by verisma icon" className='pbv-icon' />
        </div>
    );
}